import {React,useEffect,useState,useContext} from 'react'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from '../../../App';
import {API_URL}  from '../../../Constant';
import messages from '../../../assets/Messages.json';
import { useNavigate, useLocation  } from "react-router-dom";
import titlesData from '../../../titles.json';





function CreateNewUser() {
  
  const [userLevelList,setGetUserLevelList]=useState([]);
  const [districtList,setDistrictList]=useState([]);
  const [divisionList,setDivisionList]=useState([]);
  const [blockList,setBlockList]=useState([]);
  const [userLevel ,setuserLevel]=useState('');
  const [districtCode,setDistrictCode]=useState('');
  const [divisionCode,setDivisionCode]=useState('');
  const [roleCode, setRoleCode] = useState([]);
  const [blockCode,setBlockCode]=useState('');
  const [isDistrictVisible ,setIsDistrictVisible]=useState(false);
  const [isDivisionVisible ,setIsDivisionVisible]=useState(false);
  const [isBlockVisible ,setIsBlockVisible]=useState(false);
  const [isRoleVisible ,setIsRoleVisible]=useState(false);
  const [roleName ,setRoleName]=useState('');
  const [name ,setName]=useState('');
  const [userId ,setUserId]=useState('');
  const [password ,setPassword]=useState('');
  const [confirmPassword ,setConfirmPassword]=useState('');
  const [email ,setEmail]=useState('');
  const [initialUser, setInitialUser] = useState(true)
  
  const location = useLocation();
  const navigate = useNavigate();
  const token=useContext(MyContextProvider).token;
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    showLoading(true)
      // All user Level list
      const fetchUserLevel = async () => {
        try {
          const response = await axios.get(`${API_URL}api/getallusertypemaster`, config);
          const getUserLevel = response.data;

          if (getUserLevel.status) {
            setGetUserLevelList(getUserLevel.data);
            showLoading(false);
          }
        } catch (error) {
          console.error(error);
          showLoading(false);
        }
      };
    
      // All district list
      const fetchDistrictList = async () => {
        try {
          const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
          const allDistrict = response.data;

          if (allDistrict.status) {
            setDistrictList(allDistrict.data);
            showLoading(false);
          }
        } catch (error) {
          console.error(error);
          showLoading(false);
        }
      };
      // All Division  list
      const fetchDivisionList = async () => {
        try {
           const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
           const allDivision = response.data;
  
          if (allDivision.status) {
            setDivisionList(allDivision.data);
            showLoading(false);
          }
        } catch (error) {
          console.error(error);
          showLoading(false);
        }
      };

      // All Block  list
      const fetchBlockList = async () => {
        try {
            const response = await axios.get(`${API_URL}api/getallblocklist`, config);
            const allBlock = response.data;
  
          if (allBlock.status) {
            setBlockList(allBlock.data);
            showLoading(false);
          }
        } catch (error) {
          console.error(error);
          showLoading(false);
        }
      };

     
    fetchBlockList();
    fetchDivisionList();
    fetchDistrictList();
    fetchUserLevel();

  },[]);


  useEffect(() => {
    if(location.state !== null){

      setInitialUser(false)
      const { userEditDataObject } = location.state || {};
      setName(userEditDataObject.USER_NAME);
      setuserLevel(userEditDataObject.USER_TYPE_CODE);
      setUserId(userEditDataObject.USER_ID)
      setEmail(  userEditDataObject.EMAIL==='null' && userEditDataObject.EMAIL.trim()===null ? '' : userEditDataObject.EMAIL)
      setPassword(userEditDataObject.PASSWORD)
      let dataObj={
        userTypeCode: userEditDataObject.USER_TYPE_CODE.toString() ,
        roleCode: userEditDataObject.ROLE_CODES,
        userLevelLocation: userEditDataObject.USER_LEVEL_LOCATION,

      }
       handleUserLevelOnChange(dataObj,'update')
     
    }else{
      setInitialUser(true)
      handleResetForm()
    }
  }, [location.state]);


const handleUserLevelOnChange = async (e,type='') => {
  
    const value =   e && e.target ? e.target.value : e.userTypeCode;
    setuserLevel(value);
    let userLevelLocation='';
    let post_data={};
 
 if (type === '') {
      setRoleCode([]);
      setBlockCode('');
    } else { //update
     
      userLevelLocation= e.userLevelLocation;
      if(value==='2' ||  value==='3' || value==='4'){
        post_data={
          user_level: value,
          div_dis_code: userLevelLocation
          }
          await fetchRole(post_data)
      }
      setRoleCode(e.roleCode !== null ?  e.roleCode.split(',') : []);
    }
 
    switch (value) {
      case '1': // USER LEVEL
      setIsDivisionVisible(false);
      setIsDistrictVisible(false);
      setIsBlockVisible(false);
      setIsRoleVisible(true)
       post_data={
            user_level: "1",
            div_dis_code: ""
        }
      await fetchRole(post_data)
      break;
      case '2': // DIVISION LEVEL
        setIsDivisionVisible(true);
        setIsDistrictVisible(false);
        setIsBlockVisible(false);
        setIsRoleVisible(type ? true :false)

        setDivisionCode(userLevelLocation)
      break;
      case '3': // DISTRICT LEVEL
        setIsDistrictVisible(true);
        setIsDivisionVisible(false);
        setIsBlockVisible(false);
        setIsRoleVisible(type ? true :false)
        setDistrictCode(userLevelLocation)
        break;
      case '4': // BLOCK LEVEL
        setIsBlockVisible(true);
        setIsDistrictVisible(false);
        setIsDivisionVisible(false);
        setIsRoleVisible(type ? true :false)
        setBlockCode(userLevelLocation)
        break;
      default:
        setIsBlockVisible(false);
        setIsDistrictVisible(false);
        setIsDivisionVisible(false);
        setIsRoleVisible(false)
       
    }
  };
  
const handleDivisionNameOnChange = async (e) => {
    try {
      setDivisionCode(e.target.value);
      setRoleName('');
  
      if (e.target.value === '') {
        setIsRoleVisible(false);
        return;
      }
  
      let post_data = {
        user_level: userLevel,
        div_dis_code: e.target.value
      };
  
      await fetchRole(post_data);
      setIsRoleVisible(true);
  
    } catch (error) {
      console.error('Error fetching role:', error);
    }
  }

const handleDistrictNameOnChange= async(e)=>{
    
    try{
        setDistrictCode(e.target.value);
        setRoleName('');

        if (e.target.value === '') {
          setIsRoleVisible(false)
          return;
        }
        let post_data={
          user_level: userLevel,
          div_dis_code: e.target.value
        }
      
        await fetchRole(post_data)
        setIsRoleVisible(true)

    }catch(err){
       console.error('Error fetching role:', err);
    }
   
}




const fetchRole= async(post_data)=>{
      showLoading(true);
      try {
        const response = await axios.post(`${API_URL}api/account/roles`, post_data,config);
        const allRoles = response.data;
      if (allRoles.status) {
         setRoleName(allRoles.data.GroupCodes);
        showLoading(false);
      }
    } catch (error) {
      console.error(error);
      showLoading(false);
    }

  }


const handleSaveClick = async(e) => {
    e.preventDefault();
  
    if (name === '') {
      toast.error(messages.USER_NAME_MSG, messages.COLOR_RED);
      return false;
    } else if (!handleInputUserName(name)){
      return false;
    }
  
    if (userLevel === '') {
      toast.error(messages.USER_LEVEL_MSG, messages.COLOR_RED);
      return false;
    }
  
    if (userId === '') {
      toast.error(messages.USERID_MSG, messages.COLOR_RED);
      return false;
    } else if (!handleInputUserId(userId)) {
      return false;
    }
  
    if (password === '') {
      toast.error(messages.PASSWORD_MSG, messages.COLOR_RED);
      return false;
    } else if (!handleInputPassword(password)) {
      return false;
    }
  
    if (confirmPassword === '' && initialUser) {
      toast.error(messages.CONFIRM_PASSWORD_MSG, messages.COLOR_RED);
      return false;
    } else if (password !== confirmPassword && initialUser) {
      toast.error(messages.PASSWORD_MATCH_MSG, messages.COLOR_RED);
      return false;
    }
  
    // if (email === '') {
    //   toast.error(messages.VALID_EMAIL_MSG, messages.COLOR_RED);
    //   return false;
    // } else 

    if (email && !handleInputEmailValid(email)) {
      return false;
    }
    
  let postData={
      first_name: name.trim(),
      user_level: userLevel,
      division_code: divisionCode,
      district_code: districtCode,
      block_code: blockCode,
      role_name: roleCode,
      user_Id: userId.trim(),
      password: password,
      email: (email===null)? '':email.trim()
    }
  
    

    

    showLoading(true);
    if(initialUser){ //insert

   
          try {
            const registrationResult  = await axios.post(`${API_URL}api/account/registration`, postData,config);
            const response = registrationResult.data;
          
          if (response.status) {
              toast.success(response.message, messages.COLOR_RED);
              handleResetForm()
          }else{
              toast.error(response.message, messages.COLOR_RED);
          }
        
          } catch (error) {
            console.error(error);
          }finally {
            setTimeout(()=>{
              navigate('/listUsers')
              showLoading(false);
            },700)
           
           
        }

  }else{ //update
       try {

      

        const updateResult  = await axios.put(`${API_URL}api/account/updateUserData/${postData.user_Id}`, postData,config);
        const response = updateResult.data;
       
     if (response.status) {
          toast.success(response.message, messages.COLOR_RED);
          handleResetForm()
      }else{
            toast.error(response.message, messages.COLOR_RED);
        }
      
      } catch (error) {
        console.error(error);
      }finally {
        setTimeout(()=>{
          navigate('/listUsers')
          showLoading(false);
        },1000)
        
    }

   }




  }
  
const handleResetForm=()=>{
      setName('')
      setUserId('')
      setPassword('')
      setConfirmPassword('')
      setEmail('')
      setuserLevel('')
      setIsDivisionVisible(false);
      setIsDistrictVisible(false);
      setIsBlockVisible(false);
      setIsRoleVisible(false)

}



const isStringValid = (inputString) => {
    const minLength = 8;
    const maxLength = 20;
    const trimmedString = inputString.trim();
    const isLengthValid = trimmedString.length >= minLength && trimmedString.length <= maxLength;
  
    return isLengthValid;
  };

 const handleInputPassword= (pwd)=>{
     if(!isStringValid(pwd)){
      toast.error(messages.PASSWORD_MIN_AND_MAX_LENGTH_MSG, messages.COLOR_RED);
      return false;
    }
    return validatePasswordComplexity(pwd);
 }

 const validatePasswordComplexity = (pwd) => {
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const numberRegex = /[0-9]/;
  const specialCharRegex = /[@#\.!$%^&*()]/;

  if (!uppercaseRegex.test(pwd)) {
    toast.error(messages.PASSWORD_A_Z_MSG, messages.COLOR_RED);
    return false;
  }

  if (!numberRegex.test(pwd)) {
    toast.error(messages.PASSWORD_0_9_MSG, messages.COLOR_RED);
    return false;
  }

  if (!lowercaseRegex.test(pwd)) {
    toast.error(messages.PASSWORD_a_z_MSG, messages.COLOR_RED);
    return false;
  }

  if (!specialCharRegex.test(pwd)) {
    toast.error(messages.PASSWORD_SPECIAL_CHARACTER_MSG, messages.COLOR_RED);
    return false;
  }
  return true;
};

 const handleInputEmailValid = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
   if(!emailRegex.test(email)){
    toast.error(messages.VALID_EMAIL_MSG, messages.COLOR_RED);
    return false;
  }else{
    return true;
  }
};


const [userNameError, setUserNameError] = useState("");
const [userIdError, setUserIdError] = useState("");

const handleInputUserName = (userName) => {
  if (userName.length >= 5 && userName.length <= 23) {
    setUserNameError(""); 
    return true;
  } else {
    const errorMessage = messages.USER_NAME_CHARACTERS_MSG;
    setUserNameError(errorMessage); 
    return false;
  }
};


const handleInputUserId = (userId) => {
  if (userId.length >= 5 && userId.length <= 23) {
    setUserIdError(""); 
    return true;
  } else {
    const erroridMessage = messages.USER_ID_CHARACTERS_MSG;
    setUserIdError(erroridMessage); 
    return false;
  }
};



const handleRoleChange=(e)=>{
  const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
  setRoleCode(selectedValues);
}

const storedLanguage = localStorage.getItem('language');

  return (
    <>
   <ToastContainer />
    <GlobalLoading />
   
  <div className="container-fluid py-3">
     <div className="card mx-3 mb-3">
        <div className="card-body">
        <h4 className="page_heading">
        {initialUser ? 
          (storedLanguage === 'hi' ? titlesData.hi.REGISTER : titlesData.en.REGISTER)
          : 
          (storedLanguage === 'hi' ? titlesData.hi.UPDATE_USER_DETAILS : titlesData.en.UPDATE_USER_DETAILS)
        }
          
          </h4>
            <div className="row">

              <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <label><span className="text-danger">*</span> Name</label>
                  <input
                    type="text"
                    name="user_name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control"
                    onBlur={(e) => handleInputUserName(e.target.value)}
                 />
                 {userNameError && <i style={{ color:'red',fontSize: '12px'}}>{userNameError}</i>}
               </div>

               <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <label><span className="text-danger">*</span> User Level </label>
                    <select 
                      value={userLevel} 
                      name="user_level_name" 
                      className="form-select"
                      onChange={handleUserLevelOnChange}
                     >
                    <option  value=''>[--Select--]</option>
                    { userLevelList.length > 0 && userLevelList.map((ele,i)=>(
                      <option key={i} value={ele.USER_TYPE_CODE}>
                        {ele.USER_TYPE}
                      </option>
                    ))}
                    </select>               
              </div>


             { isDivisionVisible &&
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <label><span className="text-danger">*</span> Division </label>
                  <select 
                    name="division_name" 
                    className="form-select"
                    onChange={handleDivisionNameOnChange}
                    value={divisionCode}
                    >
                  <option value=''>[--Select--]</option>
                  { divisionList.length > 0 && divisionList.map((ele,i)=>(
                    <option key={ele.DIVISION_NAME} value={ele.DIVISION_CODE}>
                      {ele.DIVISION_NAME}
                    </option>
                  ))}
                  </select>
                </div>
             }

          
            { isDistrictVisible && 
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                <label><span className="text-danger">*</span> District  </label>
                <select 
                  name="district_name" 
                  className="form-select" 
                  onChange={handleDistrictNameOnChange}
                  value={districtCode}
                >
                <option value=''>[--Select--]</option>
                { districtList.length > 0 && districtList.map((ele,i)=>(
                  <option key={i} value={ele.DISTRICT_CODE}>
                    {ele.DISTRICT_NAME}
                  </option>
                ))}
                </select>
             </div>
            }

            { isBlockVisible && 
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <label><span className="text-danger">*</span> Block   </label>
                  <select 
                    name="block_name" 
                    className="form-select"
                    onChange={(e)=>setBlockCode(e.target.value)}
                    value={blockCode}
                   >
                    <option value=''>[--Select--]</option>
                    { blockList.length > 0  && blockList.map((ele,i)=>(
                      <option key={i} value={ele.BLOCK_CODE}>{ele.BLOCK_NAME}</option>
                    ))}
                  </select>
               </div>
            }
             
            { isRoleVisible && 
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <label>Role(s)   </label>
                  <select 
                    name="role_name" 
                    multiple 
                    className="form-select role_multiselect_height" 
                    onChange={handleRoleChange}
                    value={roleCode}
                    >
                  <option value="" disabled>[--None--]</option>
                  { roleName && roleName.map((ele,i)=>(
                    <option key={i} value={ele.roleCode}>
                      {ele.roleName }
                    </option>
                  ))}
                  </select>
                </div>
             } 

               <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <label><span className="text-danger">*</span> User ID </label>
                  <input 
                    disabled={!initialUser}
                    type="text" 
                    value={userId} 
                    onChange={(e)=>setUserId(e.target.value)} 
                    className="form-control"
                    onBlur={(e)=>handleInputUserId(e.target.value)}
                  />
                  {userIdError && <i style={{ color:'red',fontSize: '12px'}}>{userIdError}</i>}
               </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                   <label><span className="text-danger">*</span> Password </label>
                    <input 
                      type="password" 
                      value={password}
                      onChange={(e)=>setPassword(e.target.value)} 
                      className="form-control" 
                      onBlur={(e)=>handleInputPassword(e.target.value)}
                    />
                </div>
                {initialUser &&
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                    <label><span className="text-danger">*</span> Confirm New Password  </label>
                      <input 
                        type="password" 
                        value={confirmPassword}
                        onChange={(e)=>setConfirmPassword(e.target.value)}  
                        className="form-control"
                      />
                </div>
             }

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                    <label><span className="text-danger"></span> Email ID  </label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={email}
                      onChange={(e)=>setEmail(e.target.value)}
                      // onBlur={(e)=>handleInputEmailValid(e.target.value)}
                    />
                </div>

              <div className="mb-4">
                 <button  
                  onClick={handleSaveClick} 
                  type="submit" 
                  className="btn btn_orange"
                  >
                  {initialUser ? 'Submit' : 'Update' }
                  </button>

                <button  
                 onClick={(e)=>navigate('/dashboard')} 
                 type="submit" 
                 className="btn btn_orange ms-1"
                 >
                 Cancel
               </button>

               { initialUser &&
                 <button  
                 onClick={handleResetForm} 
                 type="submit" 
                 className="btn btn_orange ms-1"
                 >
                 Reset
               </button>
               
                }
              </div>

        </div>
      </div>
    </div>
    </div>
    
    </>
  )
}

export default CreateNewUser